import { useCallback } from 'react';
import { logEvent as firebaseLogEvent } from 'firebase/analytics';
import { deleteToken } from 'firebase/messaging';

import { useFirebaseConfigSessionStore } from '../stores';

export const useFirebaseConfig = () => {
  const { analytics, messaging } = useFirebaseConfigSessionStore();

  const logEvent = useCallback(
    (eventName: string, eventParams?: Record<string, string>) => {
      if (analytics) {
        firebaseLogEvent(analytics, eventName, eventParams);
      }
    },
    [analytics],
  );

  const deleteFirebaseToken = useCallback(() => {
    if (messaging) {
      deleteToken(messaging);
    }
  }, [messaging]);

  const unregisterServiceWorker = useCallback(() => {
    const firebaseScope = '/firebase-push-notification-scope';
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration(firebaseScope).then(registration => {
        if (registration) {
          registration.unregister();
        }
      });
    }
  }, []);

  return {
    deleteFirebaseToken,
    logEvent,
    unregisterServiceWorker,
  };
};
